export default __webpack_public_path__ + "static/media/sit-logo.f25d2b12.svg";